import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { FormSubmissionFlat } from '../../../../../models/entities/forms/form-submission';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RequestFormSubmissionApprovalsComponent } from '../request-form-submission-approvals/request-form-submission-approvals.component';

export interface RequestFormSubmissionApproverDialogInput
{
    formSubmission: FormSubmissionFlat;
}

@Component({
    selector: 'app-request-form-submission-approver-dialog',
    templateUrl: './request-form-submission-approver-dialog.component.html',
    standalone: true,
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        RequestFormSubmissionApprovalsComponent,
    ],
})
export class RequestFormSubmissionApproverDialogComponent
{
    constructor(
            @Inject(MAT_DIALOG_DATA) public data: RequestFormSubmissionApproverDialogInput,
    ) {
    }
}
